import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class BalanceService {

  cardStatus$: BehaviorSubject<string> = new BehaviorSubject<string>('')

  constructor(private dataService: DataService) { }

  getBalance(data: any) {
    return this.dataService.post('/cardholder/cardholderdetails', data)
  }
  GetStopReason() {
    return this.dataService.getData('/cardholders/GetStopReason', true)
  }

  getStatus(data: any) {
    return this.dataService.post('/cardholder/cardStatus', data).pipe(tap(value => {
      sessionStorage.setItem('cardStatus', value.resultString.status)
      this.cardStatus$.next(value.resultString.status)
    }))
  }

  getCardholderStatement(payload) {
    return this.dataService.post('/cardholder/statement', payload)
  }

  getSmsNotification(payload) {
    return this.dataService.post('/cardholder/updateSmsnotification', payload)
  }

  getCardStatusObs() {
    return this.cardStatus$.asObservable()
  }

  getExcelStatement(payload) {
    return this.dataService.post('/cardholder/download_statement', payload)
  }
  getPdfStatement(payload) {
    return this.dataService.post('/cardholder/cardholderscardstatement', payload)
  }
  getproductlist() {
    return this.dataService.getData('/adminroute/listAllProfileType', true)
  }
  getproduct_name_img_list() {
    return this.dataService.getData('/cardholder/getproductlist', true)
  }


}
